export default "__VITE_PUBLIC_ASSET__b9c59a3c__"